// extracted by mini-css-extract-plugin
export default {"fluid":"Image_fluid__kj5-K"};